<template lang="pug">
.d-flex.flex-column.justify-space-between
  img.product-card-img.pa-3(v-responsive="1.6", :src="img + '?resize=1&w=300'")
  .product-card-title.font-weight-bold.text-body-2.text-capitalize.grey--text.text--darken-4.px-2.text-center.mt-3.mb-4
    .open-sans {{ title }}
  v-btn(:to="to", color="primary", tile, small, block, max-height="28px") VER DETALHES
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    img: {
      type: String,
      required: true,
    },
    to: {
      type: String,
      required: true,
    },
  },
};
</script>

<style>
.product-card-img {
  border: 1px solid #ddd;
  width: 100%;
  object-fit: contain;
}
.product-card-title {
  border: 3px solid var(--v-primary-base);
  border-width: 0px 0px 0px 3px;
}
</style>
